<template>
    <div
        class="z-hero"
        :class="getHeroClass"
        itemscope
        itemtype="https://schema.org/WebPage"
    >
        <div
            class="z-hero__media-container"
            :style="getHeroStyle">
            <z-video
                class="z-hero__video"
                v-if="mediaSrc && type === 'video'"
                :src="mediaSrc"
                :controls="false"
                loop
                autoplay
                muted
                playsinline
            />
            <div class="z-hero__wrapper z-hero__wrapper container">
                <slot
                    v-if="slots['top']"
                    name="top" />
                <slot
                    v-if="slots['tag']"
                    name="tag" />
                <z-caption
                    :tag="heroTitleTag"
                    :size="titleSize"
                    class="z-hero__title"
                    :class="{'z-hero__title--not-tag': !slots['tag']}"
                    v-html="currentTitle"
                    itemprop="name"
                >

                </z-caption>
                <div
                    class="z-hero__description"
                    v-if="description"
                    v-html="description"
                    itemprop="description"
                ></div>
                <slot
                    v-if="slots['bottom']"
                    name="bottom" />
                <slot
                    v-if="slots['bubble']"
                    name="bubble"
                />

                <div v-if="heroSocialList || heroBubble" class="z-hero__asside-wrapper container">
                    <div class="z-hero__asside">
                        <div v-if="heroBubble" class="z-hero__asside-bubble" v-html="heroBubble">
                        </div>

                        <div v-if="heroSocialList" class="z-hero__asside-socials">
                            <z-link
                                v-for="link in heroSocialList"
                                :key="link.id"
                                :href="link.link"
                                class="z-hero__social-link"
                                target="_blank"
                                rel="noopener"
                            >
                                <z-icon
                                    :name="link.icon"
                                    width="32"
                                    height="32"
                                />
                            </z-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div
            v-if="mediaSrc && !bgImage"
            :style="getHeroStyle"
            class="z-hero__image"
            itemprop="image"
            aria-hidden="true"
        >
        </div>
    </div>
</template>

<script setup>
import { computed, useSlots } from 'vue'
import { useStore } from 'vuex';
import {useGetter} from '@/composable/useGetter'

const props = defineProps({
    title: {
        type: String,
        default: ''
    },
    description: {
        type: String,
        default: '',
        comment: 'Дополнительный текст под заголовком'
    },
    src: {
        type: String
    },
    bgImage: {
        type: Boolean,
        default: true,
        comment: 'Картинка фоном под текстовым контентом'
    },
    position: {
        type: String,
        default: '50% 50%',
        comment: 'Background position for image'
    },
    type: {
        type: String,
        validator: (prop) => ['video', 'image'].includes(prop)
    }
})

const slots = useSlots()
const store = useStore();
const {device} = useGetter(['device'])

const heroTitle = computed(() => store.getters.heroTitle);
const heroTitleTag = computed(() => store.getters.heroTitleTag);
const heroImage = computed(() => store.getters.heroImage)
const heroBubble = computed(() => store.getters.heroBubble)
const heroSocialList = computed(() => store.getters.heroSocialList)

const currentTitle = computed(() => {
    return heroTitle.value || props.title;
});

const titleSize = computed(() => {
    if(currentTitle.value?.length > 60 ) {
        return '2xl'
    }
    return '3xl'
})

const mediaSrc = computed(() => {
    if(props.type === 'image'){
        return heroImage.value ? heroImage.value : props.src
    }

    return props.src
})

const getHeroClass = computed(() => {
    return {
        'z-hero--bg-image': props.type === 'image' && mediaSrc.value,
        'z-hero--bg-video': props.type === 'video' && mediaSrc.value,
        'z-hero--default': !props.type || (!props.bgImage && !props.src)
    }
})
const getHeroStyle = computed(() => {
    if (props.type === 'image') {
        return `background-image: url(${mediaSrc.value}); background-position: ${props.position};`
    }
})

defineExpose({
    props
})
</script>

<style lang="scss" src="./index.scss"></style>
